<template>
  <div>
  
    <v-card>
      <v-card-title>
        <!-- ویرایش محصول قبلا اینجا انجام می‌شد که دیگر در صفحه جزئیات به همراه مشاهده و گفتگو انجتت می شود -->
        <span>
          {{ $store.getters.supplierProductIsEdit ? 'ویرایش ' : 'فرم ایجاد  شناسنامه در حوزه : ' }}
          </span
        > <span style="font-weight: 700;color: blue;">{{ categoryTypeDisplayName }}</span>
      </v-card-title>
      <v-card-text>
        <supplier-product-form
          :categoryType="supplierProductType"
          :categoryTypeDisplayName="categoryTypeDisplayName"
          :actionName="actionName"
       

        >
        </supplier-product-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
import { RepoFactory } from '@/baseRepository/Factory';
import SupplierProductForm from '../components/SupplierProductNewForm.vue';
import Swal from 'sweetalert2';
export default {
  components: {
    SupplierProductForm,
  },
  data() {
    return {
      categoryTypeItemsList: [],
      categoryTypeDisplayName: null,
      backButtonPrevented:false,
    };
  },
  
  mounted(){
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.popStateListener);
  },
  destroyed(){
    this.backButtonPrevented = true;
    this.popStateListener();
  },
  computed: {
    actionName() {
      // We should determine which Action is going done of 4 actions :
      // 1: "NewProdNoBase"
      // 2: "EditProdNoBase"
      // 3: "NewProdByBase"
      // 4: "EditProdByBase"
      console.log("params in 1")
      console.log(this.$route.params)
 
     return this.$route.params.actionName;
    },
     
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    // id() {
    //   return this.$route.params.id;
    // },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
    supplierProductType() {
      return this.$route.params.supplierProductType;
    },
  },
  created() {
    this.getCategoryTypeItemsList();
  },
  watch: {
    supplierProductType(after, before) {
      if (after) {
        this.getCategoryTypeLabel(after);
      }
    },
  },
  methods: {
      popStateListener(event) {
  if (this.backButtonPrevented === false){
    history.pushState(null, document.title, location.href);
  Swal.fire({
        html: `شما در حال ترک عملیات نا تمام هستید و اطلاعات ثبت شده از بین خواهد رفت. آیا مطمئن به ترک این بخش بدون اتمام عملیات هستید؟`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if(result.value){
          window.removeEventListener('popstate', this.popStateListener);
         this.closeEditForm();
        }
        
      });
  } else {
      window.removeEventListener('popstate', this.popStateListener);
      // history.back();
  }
},
    getCategoryTypeItemsList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.productBaseUrl)
        .then(({ data }) => {
          this.categoryTypeItemsList = data;
          this.getCategoryTypeLabel(this.supplierProductType);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getCategoryTypeLabel(categoryType) {
      if (this.categoryTypeItemsList.length) {
        let result = null;
        result = this.categoryTypeItemsList.find(
          (el) => el.title == categoryType
        );
        this.categoryTypeDisplayName = result ? result.displayName : result;
      }
    },
  },
};
</script>

<style>
</style>